import { useAlert } from '@src/components/Alert';
import { CustomerBalanceTransactionStatusEnum, useWLOrderFormDispatch } from '@talos/kyoko';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { createBalanceTransactionThunk } from './createBalanceTransactionThunk';

export function useSendBalanceTransaction() {
  const navigate = useNavigate();
  const dispatch = useWLOrderFormDispatch();
  const { open } = useAlert();
  const sendBalanceTransaction = useCallback(async () => {
    const response = await dispatch(createBalanceTransactionThunk());

    if (createBalanceTransactionThunk.fulfilled.match(response) && response.payload) {
      const res = response.payload;
      if (
        res.Status === CustomerBalanceTransactionStatusEnum.Completed ||
        res.Status === CustomerBalanceTransactionStatusEnum.Rejected
      ) {
        navigate(`confirmation?transactionID=${res.TransactionID}`);
        return response.payload;
      }
    }
    if (createBalanceTransactionThunk.rejected.match(response)) {
      const errorMsg = typeof response.payload === 'string' ? response.payload : response.error.message;
      open({
        title: 'Error',
        message: errorMsg,
      });
      return errorMsg;
    }
    return undefined;
  }, [dispatch, navigate, open]);

  return sendBalanceTransaction;
}
